export default __webpack_public_path__ + "static/media/openlayers.26bc56c7.svg";